import { getApp, initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth, connectAuthEmulator } from 'firebase/auth';


// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase app
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Functions with explicit region for 2nd gen callable functions
export const functions = getFunctions(firebaseApp, 'europe-west1');

// Initialize Firebase Auth
export const auth = getAuth(firebaseApp);

// Connect to local emulator only in development environment
// REACT_APP_ENVIRONMENT is set in .env files:
// - 'development' for local development with emulators
// - 'production' for production deployment
if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  console.log('Connecting to Firebase emulators (development mode)');
  
  // Default port for Firebase Functions emulator is 5001
  connectFunctionsEmulator(functions, 'localhost', 5001);
  
  // Default port for Firebase Auth emulator is 9099
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}

/**
 * Helper function to create a callable function with extended timeout
 * @param name The name of the callable function
 * @param timeout Optional timeout in milliseconds (default: 300000ms / 5 minutes)
 * @returns A callable function with configured timeout
 */
export const createCallable = <T = any, R = any>(name: string, timeout: number = 300000) => {
  return httpsCallable<T, R>(functions, name, { timeout });
};
